import AppService from "../../services/app.service";
import DasboardService from "../../services/DashboardService";
import {
  MessageService,
  getAwsUrlToViewMedia,
} from "../../services/MessageService";

export { getAwsUrlToViewMedia };

const unwrap = (payload) => {
  if (payload == null) return payload;
  if (typeof payload === "object" && !Array.isArray(payload) && "data" in payload) {
    return payload.data ?? payload;
  }
  return payload;
};

/**
 * Dashboard-only endpoints via parent AppService (401 refresh included).
 */
const v2DashboardApi = () =>
  Object.freeze({
    getClientAISummaryByAccount: async (accId) => {
      return DasboardService().getClientAISummaryByAccount(accId);
    },
    getPurchaseTypes: async (accId) => {
      const response = await AppService.getAllWithData(
        "accounts/purchaseTypes",
        accId
      );
      return unwrap(response?.data ?? response);
    },
    getSimUsedCount: async (accId) => {
      return unwrap(await AppService.get(accId, "accounts/simUsedCount"));
    },
    getTop3ByAccount: async (accountId) => {
      const response = await AppService.getAllWithData("sims/top-3", accountId);
      return unwrap(response?.data ?? response);
    },
    getGlobalTop3: async () => {
      const response = await AppService.getAll("sims/global-top-3");
      return unwrap(response?.data ?? response);
    },
    getAllUserMessages: async (accId, userId) => {
      return MessageService.getAllUserMessages(accId, userId);
    },
    dontShowMessageAgain: async (accId, userId, messageIds) => {
      return MessageService.dontShowMessageAgain(accId, userId, messageIds);
    },
  });

export default v2DashboardApi;
